import ShippingSVG from "@design-system/ui-icons/vanilla/Shipping"
import { createIcon } from "../createIcon"

export const ShippingIcon = createIcon(ShippingSVG)
